import { forwardRef, RefObject } from 'react';
import { NavLink, useSearchParams, NavLinkProps } from 'react-router';

import { linkWithQuery } from '@labradorsports/utils';

type NavLinkWithQueryProps = Omit<NavLinkProps, 'to'> & {
    to: string;
    ref: RefObject<any>;
};

export const NavLinkWithQuery = forwardRef<any, NavLinkWithQueryProps>(({ to, ...rest }, ref) => {
    const [searchParams] = useSearchParams();

    return <NavLink ref={ref} to={linkWithQuery(to, searchParams)} {...rest} />;
});

export default NavLinkWithQuery;
